import { atom } from "jotai";

/**
 * Tracks which chart IDs currently have a forecast update in progress.
 * Used to coordinate between useChartWorkingForecast (writer) and
 * useChartSelections (reader) without duplicating the forecast hook.
 */
export const forecastUpdatingChartsAtom = atom<Record<string, boolean>>({});
